import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { CoreCommonModule } from '@citi-gcg-173875/citi-common-modules';
import { Cookie, UnmanagedCookieService } from 'ng2-cookies';
import * as i2 from '@citi-gcg-173875/citi-http';
import { BehaviorSubject, EMPTY, of, catchError, map } from 'rxjs';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3 from '@citi-gcg-173875/citi-utils';
import * as CryptoJS from 'crypto-js';
import * as i2$1 from '@citi-gcg-173875/citi-branding';
import { Layouts } from '@citi-gcg-173875/citi-branding';

const URI_CONST = {
    getAuthorize: '/authorize',
    getAuthorizeToken: '/oauth/token'
};

// Service to share data between components
class AssistedChannelDataShareService {
    constructor() {
        this.sharedData = {};
        //for oauth token refresh
        this.oauthRedirect = new BehaviorSubject(true);
    }
    showOauthRedirect(val) {
        this.oauthRedirect.next(val);
    }
    addData(data) {
        if (data instanceof Object) {
            Object.assign(this.sharedData, data);
        }
    }
    getSharedData() {
        return this.sharedData;
    }
    resetSharedData() {
        this.sharedData = {};
    }
    removeData(key) {
        if (key !== null && key !== undefined) {
            return delete this.sharedData[key];
        }
        return undefined;
    }
    getDataForKey(key) {
        if (key !== null && key !== undefined) {
            return this.sharedData[key];
        }
        return undefined;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelDataShareService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelDataShareService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelDataShareService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: () => [] });

class AssistedChannelService {
    constructor(_router, _httpService, _activatedroute, _appConfigService, _sharedData) {
        this._router = _router;
        this._httpService = _httpService;
        this._activatedroute = _activatedroute;
        this._appConfigService = _appConfigService;
        this._sharedData = _sharedData;
        this.redirectUrl = this._appConfigService.getcsrHostName() + "/US/nga/login-sso/callback";
        this.clientId = this._appConfigService.getHttpServiceConfig().defaultHeaders.client_id;
        this.messageConfig = this._appConfigService.getMessageConfig();
        this.appId = this.messageConfig ? this.messageConfig['messageAppId'] : '';
        console.log('client_id value', this.clientId);
    }
    //generating codeChallenge to authorize the agent
    GetCodeVerifierAndCodeChallenge() {
        const codeVerifier = this.GenerateRandomCodeVerifier(128);
        const codeVerifierHash = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);
        const codeChallenge = codeVerifierHash
            .replace(/=/g, "")
            .replace(/\+/g, "-")
            .replace(/\//g, "_");
        console.log('codeVerifier', codeVerifier);
        console.log('codeChallenge', codeChallenge);
        return { codeVerifier: codeVerifier, codeChallenge: codeChallenge };
    }
    //generating random codeVerifier to authorize
    GenerateRandomCodeVerifier(length) {
        let codeVerifier = "";
        const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            codeVerifier += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return codeVerifier;
    }
    authorizationService() {
        console.log("Inside Authorize Service method");
        let sharedUserData = sessionStorage.getItem('agentId');
        this.channelID = sessionStorage.getItem('channelID');
        this.environmentID = sessionStorage.getItem('environmentID');
        console.log('sharedUserData', sharedUserData, 'channelID', this.channelID, 'environmentID', this.environmentID);
        this.smSession = Cookie.get('SMSESSION') || '';
        let codes = this.GetCodeVerifierAndCodeChallenge();
        this.codeChallenge = codes?.codeChallenge;
        this.codeVerifier = codes?.codeVerifier;
        console.log('codeVerifier Inside service', this.codeVerifier);
        console.log('codeChallenge Inside service', this.codeChallenge);
        let options = {};
        options = {
            headers: {
                "environmentId": this.environmentID,
                "Content-Type": "application/x-www-form-urlencoded"
            }
        };
        //smsession salesforce issue fix
        this.userData = "smtoken:" + this.smSession + ",userId:" + sharedUserData;
        let Base64EncodedUserData = btoa(this.userData);
        let encodedData = Base64EncodedUserData.replace(/=/g, "");
        console.log('Encoded smSession', Base64EncodedUserData);
        let requestBody = 'response_type=' + "code" + '&client_id=' + this.clientId + '&redirect_uri=' + this.redirectUrl + '&code_challenge_method=' + "S256" +
            '&code_challenge=' + this.codeChallenge + '&login_hint=' + "SM_LOGIN" + '&scope=' + "openid" +
            '&prompt=' + "none" + '&request=' + encodedData;
        const httpSuccessHandler = response => {
            console.log("Inside authorizationService success handler");
            console.log("Success Response", response);
            if (this.IsValidValue(response.authorization_code)) {
                console.log("isValidValueResponse", this.IsValidValue(response.authorization_code));
                // trigger token call
                this.authorizeTokenService(response.authorization_code);
            }
            else {
                this._router.navigate(['./errorPage'], { relativeTo: this._activatedroute });
            }
        };
        const errorHandler = (err) => {
            console.log("Inside authorizationService error handler");
            console.log("Error message:", err);
            console.log(err.status);
            this._router.navigate(['./errorPage'], { relativeTo: this._activatedroute });
            // // handling 302 scenario
            // if (err.status === 200) {
            //   this.validateUrlRedirect(err.url);
            // } else {
            //   this._router.navigate(['./errorPage'], {relativeTo: this._activatedroute});
            // }
            return EMPTY;
        };
        try {
            this._httpService.post(URI_CONST.getAuthorize, requestBody, options, httpSuccessHandler, errorHandler);
        }
        catch (e) {
            console.log('loginerror', e);
        }
    }
    authorizeTokenService(codeValue) {
        console.log("Inside token generation method");
        console.log('codeVerifier Inside token service', this.codeVerifier);
        let options = {};
        options = {
            headers: {
                "environmentId": this.environmentID,
                "Content-Type": "application/x-www-form-urlencoded"
            }
        };
        let reqBody = 'grant_type=' + "authorization_code" + '&client_id=' + this.clientId + '&code=' + codeValue + '&redirect_uri=' + this.redirectUrl + '&code_verifier=' + this.codeVerifier;
        const httpSuccessHandler = response => {
            console.log("Inside authorizeTokenService success handler");
            console.log(response);
            console.log(response.access_token);
            const targetURL = sessionStorage.getItem("targetURL");
            console.log("targetURL", targetURL);
            //check for Outh token refresh
            this._sharedData.oauthRedirect.subscribe(val => {
                this.showOuthRedirect = val;
            });
            console.log("showOuthRedirect", this.showOuthRedirect);
            if ((response.citi_authorization || response.access_token) && this.showOuthRedirect) {
                console.log("citi_authorization token", response.citi_authorization);
                console.log("access_token", response.access_token);
                document.cookie = "isLoggedIn=true; path=/; SameSite=None; Secure; domain=.citigroup.net";
                window.location.href = this._appConfigService.getcsrHostName() + '/US/nga' + targetURL;
            }
        };
        const errorHandler = (err) => {
            console.log("Inside authorizeTokenService error handler");
            console.log("Error message:", err);
            console.log(err.status);
            this._router.navigate(['./errorPage'], { relativeTo: this._activatedroute });
            return EMPTY;
        };
        try {
            this._httpService.post(URI_CONST.getAuthorizeToken, reqBody, options, httpSuccessHandler, errorHandler);
        }
        catch (e) {
            console.log(e);
        }
    }
    //Check if the input value is valid or not
    IsValidValue(value) {
        if (value === undefined || value === null || value.trim() === "") {
            return false;
        }
        return true;
    }
    validateUrlRedirect(url) {
        let queryParamMap = [{ key: '', value: '' }];
        if (url) {
            let urlSegments = url.split("?");
            //check if error response url has queryparams  or not
            if (urlSegments.length > 1) {
                //getting queryparams from the url
                let queryParams = urlSegments[1];
                let queryParamsArray = queryParams.split('&');
                queryParamsArray.forEach(element => {
                    let params = element.split("=");
                    let queryParamKey = params[0];
                    let queryParamValue = params[1];
                    queryParamMap.push({ key: queryParamKey, value: queryParamValue });
                });
                //check for queryparam key as code
                let codeQueryParamIndex = queryParamMap.findIndex(value => value.key === "code");
                if (codeQueryParamIndex > -1 && queryParamMap[codeQueryParamIndex].value && queryParamMap[codeQueryParamIndex].value !== 'null') {
                    //sending the code query param value
                    this.authorizeTokenService(queryParamMap[codeQueryParamIndex].value);
                }
                else {
                    this._router.navigate(['./errorPage'], { relativeTo: this._activatedroute });
                }
            }
            else {
                this._router.navigate(['./errorPage'], { relativeTo: this._activatedroute });
            }
        }
        else {
            this._router.navigate(['./errorPage'], { relativeTo: this._activatedroute });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelService, deps: [{ token: i1.Router }, { token: i2.HttpService }, { token: i1.ActivatedRoute }, { token: i3.AppConfigService }, { token: AssistedChannelDataShareService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: () => [{ type: i1.Router }, { type: i2.HttpService }, { type: i1.ActivatedRoute }, { type: i3.AppConfigService }, { type: AssistedChannelDataShareService }] });

class AssistedChannelDeepdropContent {
    static { this.en = {
        "content": {
            "cbol_reimagine_deepdrop": {
                "copy$$error": {
                    "CONTENT_ID": "error",
                    "GROUP_TYPE": "Container",
                    "SET_NOTIFICATION": "N",
                    "NAME": "error Page",
                    "PageSubHeader": "",
                    "SUBGROUP_TYPE": "Container",
                    "errorHeader": "We’re Currently Experiencing a Technical Issue",
                    "pageErrorMsg": "We can’t complete your verification at this time. Please try again later."
                }
            }
        }
    }; }
    static { this.es = {
        "content": {
            "cbol_reimagine_deepdrop": {
                "copy$$error": {
                    "CONTENT_ID": "error",
                    "GROUP_TYPE": "Container",
                    "SET_NOTIFICATION": "N",
                    "NAME": "error Page",
                    "PageSubHeader": "",
                    "SUBGROUP_TYPE": "Container",
                    "errorHeader": "We’re Currently Experiencing a Technical Issue",
                    "pageErrorMsg": "We can’t complete your verification at this time. Please try again later."
                }
            }
        }
    }; }
}

class AssistedChannelDeepdropConstants {
    static { this.appServiceConstants = {
        'contentService': {
            'app_id': 'cbol_reimagine_deepdrop',
            'content_keys': [
                "copy$$error",
            ]
        }
    }; }
}

class AssistedChannelContentService {
    constructor(_httpService, _sharedData) {
        this._httpService = _httpService;
        this._sharedData = _sharedData;
        this.content = {};
        this.parseContent = {};
        this.serviceName = 'contentService';
        this.locale = '';
        this.appId = '';
        this.pageContent = {};
        this.URI_CONST = {
            getErrorContentPart: '/error'
        };
        this.errorHandler = (error) => {
            return of(this.content);
        };
    }
    ;
    resolve(route, state) {
        this.appId = this._sharedData.getDataForKey('appId');
        if (route.queryParamMap.has('locale')) {
            this.locale = this.parseLangFromLocale(route.queryParamMap.get('locale'));
        }
        else if (Cookie.get('locale')) {
            this.locale = this.parseLangFromLocale(Cookie.get('locale'));
        }
        else if (sessionStorage.getItem('lang')) {
            this.locale = this.parseLangFromLocale(sessionStorage.getItem('lang'));
        }
        else {
            this.locale = 'en';
        }
        this.content = AssistedChannelDeepdropContent[this.locale];
        return this.retrieveContent();
    }
    parseLangFromLocale(locale) {
        if (locale) {
            return locale.indexOf('en') !== -1 ? 'en' : 'es';
        }
        else {
            return 'en';
        }
    }
    retrieveContent() {
        console.log('parseContent>>>', this.parseContent);
        if (Object.keys(this.parseContent).length > 0) {
            return of(this.parseContent);
        }
        else {
            const options = {
                getStaticContent: false
            };
            const url = `/staticcms/USGCB/${this.locale}_US/appid/cbol_reimagine_deepdrop.json`;
            let observable = this._httpService.get(url, options);
            observable = observable.pipe(catchError(err => this.errorHandler(err)));
            return observable.pipe(map((response) => {
                const pageContent = response;
                if (!!Object.keys(pageContent['content']).length) {
                    // merge fallback with downloaded content
                    const fallbackContent = Object.assign({}, this.content['content']['cbol_reimagine_deepdrop.json']);
                    const icmsContent = pageContent['content']['cbol_reimagine_deepdrop.json'];
                    this.content['content']['cbol_reimagine_deepdrop.json'] = Object.assign(fallbackContent, icmsContent);
                    console.log('observerable>>', this.content);
                }
                return this.transformContent();
            }));
        }
    }
    transformContent() {
        const opts = AssistedChannelDeepdropConstants.appServiceConstants[this.serviceName];
        console.log('opts>>>', opts);
        opts['content_keys'].forEach(element => {
            const contentType = element.split('$$')[0];
            const page_name = element.split('$$')[1];
            if (typeof this.parseContent[page_name] === 'undefined') {
                this.parseContent[page_name] = {};
            }
            if (typeof this.parseContent[page_name]['content'] === 'undefined') {
                this.parseContent[page_name]['content'] = {};
            }
            if (typeof this.parseContent[page_name]['errorMsg'] === 'undefined') {
                this.parseContent[page_name]['errorMsg'] = {};
            }
            if (typeof this.parseContent[page_name]['config'] === 'undefined') {
                this.parseContent[page_name]['config'] = {};
            }
            if (contentType === 'copy') {
                this.parseContent[page_name]['content'] = this.content['content'][opts['app_id']][element];
                this.parseContent[page_name]['errorMsg'] = this.content['content'][opts['app_id']][element + 'ErrMsg'];
            }
            else if (contentType === 'config') {
                this.parseContent[page_name]['config'] = this.content['content'][opts['app_id']][element];
            }
        });
        return this.parseContent;
    }
    ;
    getContent() {
        return this.parseContent;
    }
    getContentForKey(key) {
        if (key != null && key !== undefined) {
            return this.parseContent[key];
        }
        return undefined;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelContentService, deps: [{ token: i2.HttpService }, { token: AssistedChannelDataShareService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelContentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AssistedChannelContentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i2.HttpService }, { type: AssistedChannelDataShareService }] });

class ErrorComponent {
    constructor(_assistedContentService) {
        this._assistedContentService = _assistedContentService;
        this.errorHeader = '';
        this.pageErrorMsg = '';
        this.content = {};
        this.errorMsg = {};
        this.config = {};
        this.pageName = 'error';
    }
    ngOnInit() {
        console.log("Inside rei error component");
        this.getContent();
    }
    getContent() {
        const _content = this._assistedContentService.getContentForKey(this.pageName);
        this.content = _content['content'];
        this.errorMsg = _content['errorMsg'];
        this.config = _content['config'];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ErrorComponent, deps: [{ token: AssistedChannelContentService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: ErrorComponent, isStandalone: false, selector: "app-error", ngImport: i0, template: "<citi-simple-layout>\n  <h2>{{content.errorHeader}}</h2>\n\n  <p>{{content.pageErrorMsg}}</p>\n</citi-simple-layout>\n", styles: [""], dependencies: [{ kind: "component", type: i2$1.SimpleLayoutComponent, selector: "citi-simple-layout", inputs: ["theme", "endpoint", "responsive", "width", "singleBreakpoint", "cdsThemeEnabled", "pageId", "servicingType", "brandingType", "loading", "prelogin", "locale", "fullbleed", "waitMessage", "readyMessage"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-error', standalone: false, template: "<citi-simple-layout>\n  <h2>{{content.errorHeader}}</h2>\n\n  <p>{{content.pageErrorMsg}}</p>\n</citi-simple-layout>\n" }]
        }], ctorParameters: () => [{ type: AssistedChannelContentService }] });

const routes = [
    {
        path: 'errorPage',
        component: ErrorComponent
    }
];
class DeepDropAssistedRoutingModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedRoutingModule, imports: [i1.RouterModule], exports: [RouterModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedRoutingModule, imports: [RouterModule.forChild(routes), RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule]
                }]
        }] });

class DeepDropAssistedChannelModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedChannelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedChannelModule, declarations: [ErrorComponent], imports: [CoreCommonModule,
            DeepDropAssistedRoutingModule,
            Layouts] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedChannelModule, providers: [
            UnmanagedCookieService,
            AssistedChannelService,
            AssistedChannelDataShareService,
            AssistedChannelDeepdropConstants,
            AssistedChannelDeepdropContent,
            AssistedChannelContentService
        ], imports: [CoreCommonModule,
            DeepDropAssistedRoutingModule,
            Layouts] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepDropAssistedChannelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ErrorComponent],
                    imports: [
                        CoreCommonModule,
                        DeepDropAssistedRoutingModule,
                        Layouts
                    ],
                    exports: [],
                    providers: [
                        UnmanagedCookieService,
                        AssistedChannelService,
                        AssistedChannelDataShareService,
                        AssistedChannelDeepdropConstants,
                        AssistedChannelDeepdropContent,
                        AssistedChannelContentService
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AssistedChannelDataShareService, AssistedChannelService, DeepDropAssistedChannelModule };
